<script>
import UtDescriptions from "@/components/UtDescriptions.vue";
import {chemicalApi} from "@/api/chemical";

export default {
  name: 'ChemInfoDetail',
  components: {UtDescriptions},
  data(){
    return {
      id: null,
      chemical: {},
      chemicalConfig: [
        { label: '化学品中文名称', prop: 'chemName' },
        { label: '化学品别名', prop: 'chemAlias' },
        { label: 'CAS号', prop: 'chemCas' },
        { label: '英文名称', prop: 'chemEnglishName' },
        { label: 'UN编号', prop: 'unNo' },
        { label: '登记企业数量', prop: 'companyCount' },
        { label: '更新时间', prop: 'infoUpdatedTime' },
        { label: '危险性类别', prop: 'riskCategory' },
        { label: 'GHS警示词', prop: 'ghsWarnWord' },
        { label: 'GHS分类来源', prop: 'ghsClassSource' },
        { label: '象形图编码，多个逗号分隔', prop: 'ghsPictogram' },
        { label: '危险性说明H编码描述', prop: 'riskDescription' },
        { label: '外观与性状', prop: 'appearanceShape' },
        { label: 'PH值', prop: 'phValue' },
        { label: '熔点(℃)', prop: 'meltPoint' },
        { label: '沸点/沸程(℃)', prop: 'boilPoint' },
        { label: '相对密度（水=1）', prop: 'relativeDensityWater' },
        { label: '相对蒸气密度（空气=1）', prop: 'relativeVaporDensityAir' },
        { label: '饱和蒸气压(kPa)', prop: 'saturatedVaporPressure' },
        { label: '燃烧热(KJ/mol)', prop: 'combustionHeat' },
        { label: '临界温度(℃)', prop: 'criticalTemp' },
        { label: '临界压力(MPa)', prop: 'criticalPressure' },
        { label: '辛醇/水分配系数LogKow', prop: 'logKow' },
        { label: '闪点(℃)', prop: 'flashPoint' },
        { label: '自燃温度(℃)', prop: 'autoIgnitionTemp' },
        { label: '爆炸下限(%)', prop: 'explosionLowerLimit' },
        { label: '爆炸上限(%)', prop: 'explosionUpperLimit' },
        { label: '分解温度(℃)', prop: 'decompositionTemp' },
        { label: '粘度(mPa.s)', prop: 'viscosity' },
        { label: '溶解性', prop: 'solubility' },
        { label: '密度(kg/m3)', prop: 'densityKgm3' },
        { label: '完整理化特性拼接文本', prop: 'fullPhysicParam' },
        { label: '理化特性数组JSON', prop: 'physicParamJson' },
        { label: '燃烧与爆炸危险性', prop: 'burnExplodeRisk' },
        { label: '活性反应', prop: 'activeReaction' },
        { label: '禁忌物', prop: 'forbiddenMaterial' },
        { label: '中毒表现/毒性危害', prop: 'toxicSymptom' },
        { label: '职业接触限值', prop: 'careerContactLimit' },
        { label: '环境危害', prop: 'environmentHazard' },
        { label: '急救措施', prop: 'firstAidMeasure' },
        { label: '泄漏应急处置', prop: 'leakageDisposal' },
        { label: '灭火方法', prop: 'fireFightingMethod' },
      ]

    }
  },
  mounted() {
    this.fetchInfoDetail();
  },
  // 或者通过$route对象接收
  created() {
    this.id = this.$route.params.id; // 对应params传递方式
  },
  methods: {
    async fetchInfoDetail() {
      const res = await chemicalApi.getDetailById(this.id)
      if (res.code === '0000'){
        this.chemical = res.result
      }
    },
    back(){
      this.$router.back();
    }
  },
}

</script>

<template>
  <div>
    <el-card>
      <template #header>
        <div style="display: flex; align-items: center; gap: 12px;">
          <el-button type="primary" size="small" @click="back" icon="el-icon-arrow-left">返回</el-button>
          <span>危化品详情</span>
        </div>
      </template>

      <ut-descriptions :config="chemicalConfig" :data="chemical" />

    </el-card>
  </div>
</template>

<style scoped>

</style>
